import type { Step } from '../types/content'

export const steps: Step[] = [
  {
    id: 'vol',
    title: 'Faire un vol de découverte',
    description:
      'Une heure sur une base près de chez vous, aux commandes avec un instructeur. C’est le seul moyen de savoir quelle classe vous correspond.',
    detail: '60 à 120 € selon la classe',
  },
  {
    id: 'licence',
    title: 'Prendre sa licence fédérale',
    description:
      'La licence FFPLUM ouvre l’assurance responsabilité civile, l’accès aux bases et l’accompagnement de la Fédération.',
    detail: 'Dès 16 ans, 15 ans en élève pilote',
  },
  {
    id: 'formation',
    title: 'Se former en école',
    description:
      'Théorie commune aux six classes, puis pratique avec un instructeur. Pas de durée imposée : vous progressez à votre rythme.',
    detail: '15 à 30 heures de vol en moyenne',
  },
  {
    id: 'brevet',
    title: 'Obtenir son brevet de pilote',
    description:
      'Théorique national et test en vol. Le brevet est délivré à vie, sans visite médicale imposée ni renouvellement.',
    detail: 'Validité illimitée',
  },
]
